import { render, staticRenderFns } from "./ordersTable.vue?vue&type=template&id=d5bff6e0&scoped=true&"
import script from "./ordersTable.vue?vue&type=script&lang=js&"
export * from "./ordersTable.vue?vue&type=script&lang=js&"
import style0 from "./ordersTable.vue?vue&type=style&index=0&id=d5bff6e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5bff6e0",
  null
  
)

export default component.exports